import { defineMessages } from "react-intl";

const GO_TO_ACCOUNT_LINK = "go-to-account-link";

const goToAccountLinkMessages = defineMessages({
  goToMyAccount: {
    id: `${GO_TO_ACCOUNT_LINK}.go-to-my-account`,
    defaultMessage: "Go to my account"
  }
});

export default goToAccountLinkMessages;
